'use client';

import { useTranslations } from 'next-intl';
import SimpleList from '@/components/common/simple-list';
import { getFooterLinksItems } from '@/components/layout/footer/footer-links/footer-link-items';
import { useTenant } from '@/providers/TenantProvider';

const FooterLinks = () => {
  const t = useTranslations('footer');
  const {
    tenantConfig: { settings },
  } = useTenant();

  const data = getFooterLinksItems(t, settings);

  return (
    <section className="flex w-full flex-row flex-wrap pb-10 sm:flex-nowrap xl:pt-10">
      {data.map((item) => (
        <SimpleList
          key={item.id}
          data={item}
          containerClassName="w-1/2 sm:full last:mt-5 sm:last:mt-0"
        />
      ))}
    </section>
  );
};

export default FooterLinks;
